export default function toStringValues(anEnum: any): string[] {
  return Object.keys(anEnum).map((key) => anEnum[key] as string)
}
